import { render, staticRenderFns } from "./Product_setting.vue?vue&type=template&id=243c9590&scoped=true&"
import script from "./Product_setting.vue?vue&type=script&lang=js&"
export * from "./Product_setting.vue?vue&type=script&lang=js&"
import style0 from "./Product_setting.vue?vue&type=style&index=0&id=243c9590&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243c9590",
  null
  
)

export default component.exports